export default __webpack_public_path__ + "static/media/organization.a061ff47.png";